export const payload = {
  receiveMutation: 'RECEIVE_SERIES',
  receivingMutation: 'RECEIVING_SERIES',
  receiveMetadataMutation: 'RECEIVE_SERIES_METADATA',
  receiveFailureMutation: 'RECEIVE_SERIES_FAILURE',
  savingMutation: 'SAVING_SERIES',
  saveFailureMutation: 'SAVING_SERIES_FAILURE',
  incrementMutation: 'INCREMENT_SERIES_COUNT',
  updatingMutation: 'UPDATING_SERIES',
  updateFailureMutation: 'UPDATING_SERIES_FAILURE',
  deleteMutation: 'DELETE_SERIES',
  deletingMutation: 'DELETING_SERIES',
  deleteFailureMutation: 'DELETING_SERIES_FAILURE',
  resetMetaMutation: 'RESET_SERIES_META',
  clearMutation: 'CLEAR_SERIES_STATE',
  moduleName: 'series',
  endpoint: 'series',
  defaultModelGetter: 'getDefaultSeries',
  searchableFields: ['code', 'name', 'description']
}
